import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { EXPORT_STEPS, STATUSES } from '../../constants/export.constants';
import {
  getExportCountByStatusCode,
  getInfoTextByStep,
  getRecordTitle,
} from '../../utils/export.utils';
import InfoBlock from '../common/InfoBlock';

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  infoHeader: { marginBottom: 10 },
  errorMessage: { color: 'red' },
  successMessage: { color: '#00c221' },
});

const ExportInfo = ({ exportStep, resultRows = [], isPackagesExport }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const recordsWithCompletedStatusCount = getExportCountByStatusCode(resultRows, STATUSES.COMPLETE);
  const recordsWithErrorStatusCount = getExportCountByStatusCode(resultRows, STATUSES.FAIL);
  const completedTitle = getRecordTitle(recordsWithCompletedStatusCount);
  const errorTitle = getRecordTitle(recordsWithErrorStatusCount);

  return (
    <div className={classes.container}>
      {exportStep === EXPORT_STEPS.EXPORT_COMPLETED ? (
        <InfoBlock type="default">
          <div>
            <Typography variant="title2" className={classes.infoHeader}>
              {`${translateString('Export information')}:`}
            </Typography>

            <Typography>{`${translateString(
              'Exports with Complete Status'
            )}: ${recordsWithCompletedStatusCount} ${translateString(completedTitle)}`}</Typography>

            <Typography>{`${translateString(
              'Exports with Fail Status'
            )}: ${recordsWithErrorStatusCount} ${translateString(errorTitle)}`}</Typography>

            <Typography className={classes.successMessage}>
              {translateString('Export has been completed. Verify the status of each transaction.')}
            </Typography>
          </div>
        </InfoBlock>
      ) : (
        <InfoBlock>
          <Typography
            color="textSecondary"
            dangerouslySetInnerHTML={{ __html: getInfoTextByStep(exportStep, isPackagesExport) }}
          />
        </InfoBlock>
      )}
    </div>
  );
};

export default ExportInfo;
